export default __webpack_public_path__ + "static/mail-356a8462a34537921b28975ee84b2e1c.png";